/* eslint-disable no-unused-vars */
// import {useContext} from 'react';
import Head from 'next/head';
import getConfig from 'next/config';
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import styles from './styles';
import BroadbandPrequalBanner from './BroadbandPrequalBanner';
import BroadbandPrequalBannerCurve from './BroadbandPrequalBannerCurve';
import InfoBanner from './InfoBanner';
// import EirOfferCard from '../eir-offer-card/EirOfferCard';
import BroadbandOfferCardContainer from './BroadbandOfferCardContainer';
import TvOfferCardContainer from '../eir-tv/TvOfferCardContainer';
import MbbContainer from '../eir-mobile-broadband/MbbContainer';
// import BroadbandContext from './BroadbandContext.context';
import InfoCard from '../shared/InfoCard';
import EirOfferCard from '../eir-offer-card/EirOfferCard';
import BroadbandContentCarousel from './BroadbandContentCarousel';
import EirTacticalCardContainer from '../eir-tactical-offers/EirTacticalOffersContainer';
import BroadbandPrequalSecondaryBannerCurve from './BroadbandPrequalSecondaryBannerCurve';
import CrossSellContainer from '../eir-cross-sell/CrossSellContainer';
import { useToggle } from '../../hooks/useToggle';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';
import ErrorModal from '../eir-error-modal/ErrorModal';
import BroadbandPrequalTopTag from './BroadbandPrequalTopTag';
import { getLocalStorage } from '../../hooks/useLocalStorage';
import CrossSellLoader from '../eir-cross-sell/CrossSellLoader';
import FaqContainer from '../eir-mobile-broadband/FaqContainer';
import LoginMain403 from '../eir-403-login/LoginMain403';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';
import EirCompatibleAddonsContainer from '../eir-compatible-addons/EirCompatibleAddonsContainer';
import {
  getPrequalBackgroundAltText,
  getPrequalBackgroundUrl,
  isNewCustomer,
} from './Broadband.util';

const { publicRuntimeConfig } = getConfig();

const BroadbandContainer = props => {
  const [isBBOfferSelected, setBBOfferSelected] = useState(false);
  // const [isPrequaled, setIsPrequaled] = useState(false);
  const [showTv, setShowTv] = useState(false);
  const [showAddon, setShowAddon] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [contractDuration, setContractDuration] = useState('');
  const [OfferCode, setOfferCode] = useState('');
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [loadingBB, setLoadingBB] = useState(true);
  const [loadingAddon, setLoadingAddon] = useState(true);
  const [loadingTV, setLoadingTV] = useState(true);
  const [offerCardButtonDisable, setOfferCardButtonDisable] = useState(false);
  const [hideCS, setHideCS] = useState(false);
  const [isMBBJourney, setIsMBBJourney] = useState(false);
  const [FTTHinFuture, setFTTHinFuture] = useState(false);
  const [isNBIJourney, setIsNBIJourney] = useState(false);
  const [isR6NGB, setIsR6NGB] = useState(false);
  const [showPrequalTopTag, setShowPrequalTopTag] = useState(false);
  const [futureDate, setFutureDate] = useState('');
  const [futureSpeed, setFutureSpeed] = useState('');
  const [maxSpeed, setMaxSpeed] = useState(0);
  const [currentService, setCurrentService] = useState('');
  const errorBBModal = useToggle(false);
  const [compatibleAddons, setCompatibleAddons] = useState([]);

  const refNextBtn = useRef(null);
  const ref = useRef(null);

  // const [errorTrials, setErrorTrials] = useState(2);
  const theme = useTheme();
  const router = useRouter();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  // const broadband = useContext(BroadbandContext);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const smallLaptop = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const nextStep = () => {
    if (getCookie('cart_Type') === 'CHANGE_OFFER' || getCookie('cart_Type') === 'CROSS_SELL') {
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    } else if (!props.changeOffer)
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband/current-service`);
    // else router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
  };

  const slideToRef = () => {
    if (refNextBtn.current) refNextBtn.current.scrollIntoView();
  };
  const scrollToRef = () => {
    ref.current.focus();
  };
  useEffect(() => {
    if (showNext) slideToRef();
  }, [showNext]);

  useEffect(() => {
    props.setPrequal(props.isPrequal);
  }, [props.isPrequal]);

  useEffect(() => {
    if (props.hideOfferCard) setShowNext(false);
  }, [props.hideOfferCard]);

  useEffect(() => {
    if (getCookie('cart_Type') === 'CHANGE_OFFER' || getCookie('cart_Type') === 'CROSS_SELL') {
      setShowAddon(false);
    }
  }, []);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
      errorBBModal.disable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
      errorBBModal.disable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  const getUrl = () => {
    let url;
    if (sm) {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.attributes?.InfoBanner?.MobileImage?.data?.attributes?.url}`;
    } else if (smallLaptop) {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.attributes?.InfoBanner?.TabletImage?.data?.attributes?.url}`;
    } else {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.attributes?.InfoBanner?.DesktopImage?.data?.attributes?.url}`;
    }
    return url;
  };
  const getAltText = () => {
    let altText;
    if (sm) {
      altText =
        props.cmsData?.attributes?.InfoBanner?.MobileImage?.data?.attributes?.alternativeText;
    } else if (smallLaptop) {
      altText =
        props.cmsData?.attributes?.InfoBanner?.TabletImage?.data?.attributes?.alternativeText;
    } else {
      altText =
        props.cmsData?.attributes?.InfoBanner?.DesktopImage?.data?.attributes?.alternativeText;
    }
    return altText;
  };

  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      spacing={2}
      sx={styles(theme).BroadbandContainer}
      id='broadband-container'
    >
      {/* <Head>
        <title>eir Broadband and TV 123</title>
        <meta name='title' content='eir Broadband and TV' />
        <meta
          name='description'
          content='Best Gigabit Fibre Broadband Deals from €34.99/m | broadband offers from the No.1 broadband in Ireland! Buy Totally unlimited fibre broadband from just €34.99/m for 12 months.'
        />
        <meta name='robots' content='index,follow' />
      </Head> */}
      {showPrequalTopTag && futureSpeed !== '' && (
        <Grid
          item
          container
          xs={12}
          sx={{ textAlign: 'center', marginTop: '1rem', backgroundColor: 'lightblue' }}
        >
          <BroadbandPrequalTopTag
            date={futureDate}
            speed={futureSpeed}
            setShowPrequalTopTag={setShowPrequalTopTag}
          />
        </Grid>
      )}
      {!props?.hidePrequalBanner && (
        <Grid
          item
          xs={12}
          sx={[
            styles(
              theme,
              props.isPrequaled,
              props.COEligibilityStatus === 'ECC',
              props.holdPrequal,
              props.cmsData?.attributes?.Prequal?.afterPrequelDesktopbkgImg?.data?.attributes?.url,
              props.cmsData?.attributes?.Prequal?.beforePrequelDesktopbkgImg?.data?.attributes?.url,
              props.cmsData?.attributes?.Prequal?.beforePrequelMobileBkgImg?.data?.attributes?.url,
              props.cmsData?.attributes?.Prequal?.backgroundColor
            ).PrequalContainer,
            { ...(showPrequalTopTag && { marginTop: '0rem !important' }) },
          ]}
        >
          <img
            src={getPrequalBackgroundUrl(
              props?.cmsData?.attributes?.Prequal,
              isMobile,
              props.isPrequaled
            )}
            alt={getPrequalBackgroundAltText(
              props?.cmsData?.attributes?.Prequal,
              isMobile,
              props.isPrequaled
            )}
            style={{ display: 'none' }}
          />
          <BroadbandPrequalBanner
            cmsData={props.cmsData?.attributes?.Prequal}
            setPrequalStatus={props.setIsPrequal}
            errorBBModal={errorBBModal}
            setErrorModalOccurence={setErrorModalOccurence}
            errorModalOccurence={errorModalOccurence}
            refButton={ref}
            imageData={props.cmsData}
            changeOffer={props.changeOffer}
            crossSell={props.crossSell}
            COEligibilityStatus={props.COEligibilityStatus}
            // enable={props.enableModal}
            setEnableModal={props.setEnableModal}
            isMBBJourney={isMBBJourney}
            setIsMBBJourney={setIsMBBJourney}
            isNBIJourney={isNBIJourney}
            setIsNBIJourney={setIsNBIJourney}
            isR6NGB={isR6NGB}
            setIsR6NGB={setIsR6NGB}
            isPrequaled={props.isPrequaled}
            setIsPrequaled={props.setIsPrequaled}
            prequalByPhone={props.prequalByPhone}
            setPrequalByPhone={props.setPrequalByPhone}
            setPrequaledFromBanner={props.setPrequaledFromBanner}
            FTTHinFuture={FTTHinFuture}
            setFTTHinFuture={setFTTHinFuture}
            setShowPrequalTopTag={setShowPrequalTopTag}
            maxSpeed={maxSpeed}
            setMaxSpeed={setMaxSpeed}
            setFutureDate={setFutureDate}
            setFutureSpeed={setFutureSpeed}
            // errorTrials={errorTrials}
            // setErrorTrials={setErrorTrials}
            holdPrequal={props.holdPrequal}
            setNEQDetails={props.setNEQDetails}
            NEQDetails={props.NEQDetails}
            loading={loadingBB}
            setLoading={setLoadingBB}
            setCurrentService={setCurrentService}
            currentService={currentService}
            enableNBIPrevention={props.enableNBIPrevention}
            setprequalCTALoaderText={props.setprequalCTALoaderText}
            prequalCTALoaderText={props.prequalCTALoaderText}
          />
          {/* <BroadbandPrequalBannerCurve cmsData={props.cmsData?.attributes?.Prequal} /> */}
        </Grid>
      )}
      {!isMBBJourney && !isR6NGB && (
        <>
          {/* hide CO cards, if not eligible for CO */}
          {props.COEligibilityStatus !== 'ECC' && !props.hideOfferCard && (
            <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
              {/* BB tariff container */}
              <BroadbandOfferCardContainer
                cmsData={props.cmsData?.attributes}
                id={props.isPrequal ? 'BroadBand_Prequal_Offers' : 'BroadBand_Recommended_Offers'}
                key={props.changeOffer}
                loading={loadingBB}
                setLoading={setLoadingBB}
                isNBIJourney={isNBIJourney}
                staticbbCard={!props.isPrequal}
                isPrequaled={props.isPrequal}
                setShowTv={setShowTv}
                setShowAddon={setShowAddon}
                setShowNext={setShowNext}
                setContractDuration={setContractDuration}
                setOfferCode={setOfferCode}
                errorBBModal={errorBBModal}
                offerCardButtonDisable={offerCardButtonDisable} // can be used for change offer button disabling
                cmsDataImages={props.cmsData}
                changeOffer={props.changeOffer}
                offerCardTextVisible={props.offerCardTextVisible}
                setShowCrossSell={props.setShowCrossSell}
                setHideCS={setHideCS}
                myEirCOAdd={props.myEirCOAdd}
                setMyEirCOAdd={props.setMyEirCOAdd}
                hideTV={props.hideTV}
                eligibleForCO={props.eligibleForCO}
                hold={props.holdPrequal}
              />
            </Grid>
          )}
          {!props.isPrequal &&
            props.COEligibilityStatus !== 'ECC' &&
            !props.hideOfferCard &&
            props.eligibleForCO === true &&
            !props.holdPrequal && (
              <Grid item xs={12} sm={12} sx={styles(theme).ctaContainer}>
                <Button
                  variant='buttonMedium'
                  disableRipple
                  sx={styles(theme).ctaHandler}
                  onClick={scrollToRef}
                  aria-label='Check availability'
                >
                  Check availability
                </Button>
              </Grid>
            )}
          {props.isPrequal && isNewCustomer() && !props.changeOffer && !props.hidePrequalBanner && (
            <Grid item xs={12} sx={styles(theme).tacticalOfferBlock}>
              {/* pass title to the tactical container, if title coming from strapicms */}
              <Box sx={{ m: { lg: '0 3.4rem', sm: 0, xs: 0 } }}>
                <EirTacticalCardContainer
                  serviceGroupCode='DUALPLAY'
                  title='Benefits also included in your plan'
                />
              </Box>
            </Grid>
          )}

          {/* below code is commented to remove curve banner */}

          {/* {((!props.isPrequal && props.COEligibilityStatus !== 'ECC' && !props.hideOfferCard) ||
            (props.COEligibilityStatus === 'E' && !props.hideOfferCard) ||
            showTv) && (
            <BroadbandPrequalSecondaryBannerCurve cmsData={props.cmsData?.attributes?.Prequal} />
          )} */}
          {showAddon && (
            <EirCompatibleAddonsContainer
              cmsData={props.cmsData?.attributes}
              isPrequaled={props.isPrequal}
              id='Compatible_Addons'
              loading={loadingAddon}
              setLoadingAddon={setLoadingAddon}
              setCompatibleAddons={setCompatibleAddons}
              compatibleAddons={compatibleAddons}
              key={props.isPrequal}
              OfferCode={OfferCode}
            />
          )}
          {showTv || getCookie('MYEIR_BB_ADDED') === 'true' ? (
            <Grid item xs={12}>
              {/* TV tariff container */}
              {props.hideUpsellTV === false && (
                <TvOfferCardContainer
                  cmsData={props.cmsData?.attributes}
                  id='TV_Offer'
                  loading={loadingTV}
                  setLoading={setLoadingTV}
                  isPrequaled={props.isPrequal}
                  key={props.isPrequal}
                  showTv={showTv}
                  contractDuration={contractDuration || getCookie('COMMITMENT_DURATION')}
                  OfferCode={OfferCode}
                  nextStep={nextStep}
                  isCO={props.changeOffer || getCookie('MYEIR_BB_ADDED') === 'true'}
                  hideUpsellTV={props.hideUpsellTV}
                  setShowNext={setShowNext}
                  hasAddons={compatibleAddons?.length > 0}
                />
              )}
            </Grid>
          ) : (
            <Grid sx={styles(theme).blankDiv} />
          )}
          {/* cross sell container */}
          {/* {isPrequaled && ( */}
          {props.showCrossSell &&
          hideCS === false &&
          props.holdCS === false &&
          props.holdPrequal === false ? (
            <Grid
              item
              xs={12}
              sx={props.hideOfferCard && { backgroundColor: theme.palette.primary.contrastText }}
            >
              <CrossSellContainer
                cmsData={props.cmsData?.attributes}
                setOfferCardButtonDisable={setOfferCardButtonDisable}
                skipInitiate={props.skipCrossSellInitiate}
                isVisible={props.showCrossSell}
                hideTV={props.hideTV}
                hideMobile={props.hideMobile}
                setClearJourney={props.setClearJourney}
                setShowNext={setShowNext}
                COEligibilityStatus={props.COEligibilityStatus}
                subscriptionId={props.subscriptionId || getCookie('SUBSCRIPTION_ID')}
                CSFailed={props.CSFailed}
                myEirTvAdd={props.myEirTvAdd}
                setMyEirTvAdd={props.setMyEirTvAdd}
                subscriptions={props?.subscriptions}
                clearJourneyDetailsOnSubscriptionChange={
                  props?.clearJourneyDetailsOnSubscriptionChange
                }
                tvChannels={props?.cmsData?.attributes?.TVChannels}
                hold={props.holdPrequal}
                hideCS={!props.crossSell}
              />
            </Grid>
          ) : (
            ((JSON.parse(getCookie('COMP_MAP'))?.CO === true &&
              JSON.parse(getCookie('COMP_MAP'))?.COSelected === false) ||
              (JSON.parse(getCookie('COMP_MAP'))?.CO === false &&
                JSON.parse(getCookie('COMP_MAP'))?.COSelected === false &&
                JSON.parse(getCookie('COMP_MAP'))?.CS === true)) &&
            props.showCrossSell && (
              <Grid
                item
                xs={12}
                sx={props.hideOfferCard && { backgroundColor: theme.palette.primary.contrastText }}
              >
                <CrossSellLoader />
              </Grid>
            )
          )}

          {showNext && (
            <Grid
              item
              xs={12}
              ref={refNextBtn}
              sx={{
                p: { sm: '1rem 2rem' },
                pb: { xs: '3rem', sm: '64px' },
                mt: { xs: '8px' },
                maxWidth: { xs: '95%' },
              }}
            >
              <Button
                variant='buttonMedium'
                sx={{
                  ...styles(theme).submitCTAbroadband,
                  ...{ fontColor: theme.palette.primary.buttonColor },
                  margin: '0 auto',
                  mb: { xs: '94px', sm: '90px', md: '4.25rem' },
                  display: 'flex',
                }}
                onClick={() => nextStep()}
                key={showNext}
                aria-label='Proceed to give details of your current service'
              >
                Next
                <ArrowForwardIcon sx={{ ml: 1 }} />
              </Button>
            </Grid>
          )}
          {!props.isPrequal &&
            props.COEligibilityStatus !== 'ECC' &&
            !props.hidePrequalBanner &&
            props.holdPrequal === false && (
              <Grid item xs={12} md={12}>
                {/* <BroadbandPrequalSecondaryBannerCurve cmsData={props.cmsData?.attributes?.Prequal} /> */}
                <BroadbandContentCarousel
                  contentTitle={props?.cmsData?.attributes?.contentCarouselHeading?.title}
                  contentDescription={
                    props?.cmsData?.attributes?.contentCarouselHeading?.description
                  }
                  contentCarousel={props?.cmsData?.attributes?.ContentTiles}
                />
              </Grid>
            )}
          {isBBOfferSelected ? (
            <>
              <Grid item xs={10} md={4}>
                {/* Activation Cards */}
                {/* ! NOTE : Uncomment if it is required */}
                {/* <InfoCard
              src='/image/noActivationFee.png'
              alt='no activaton fee'
              title='No Set Up Fees!'
              description={`Free activation & installation worth €${128.99}`}
              textAlign='left'
              style={{ title: { mt: 0, fontSize: { xs: '1rem' } } }}
            /> */}
              </Grid>
              <Grid item xs={10}>
                {/* <EirOfferCard
              topTag='lorem'
              preTitle='eir TV'
              title='up to 500MB'
              contractLength={32}
              price={12.22}
              description='It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. '
            /> */}
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={10}>
                {/* swiper of cards */}
                {/* <Box sx={{ height: 200, width: '100%', bgcolor: 'whitesmoke' }} /> */}
              </Grid>
              <Grid item xs={12}>
                {/* banner */}
                {/* <Box sx={{ height: 200, width: '100%', bgcolor: 'whitesmoke', mb: 1 }} /> */}
              </Grid>
            </>
          )}
          {((!props.isPrequal && props.COEligibilityStatus !== 'ECC' && !props.hidePrequalBanner) ||
            props.holdPrequal === true) && (
            <Grid
              item
              xs={12}
              sx={
                styles(
                  theme,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  props.cmsData?.attributes?.InfoBanner?.DesktopImage?.data?.attributes?.url,
                  props.cmsData?.attributes?.InfoBanner?.MobileImage?.data?.attributes?.url,
                  props.cmsData?.attributes?.InfoBanner?.TabletImage?.data?.attributes?.url
                ).InfoBannerMainContainer
              }
            >
              <img
                src={getUrl()}
                alt={getAltText()}
                style={{
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  padding: 0,
                  margin: '-1px',
                  overflow: 'hidden',
                  clip: 'rect(0, 0, 0, 0)',
                  whiteSpace: 'nowrap',
                  border: 0,
                }}
              />

              <InfoBanner
                title={props.cmsData?.attributes?.InfoBanner?.InfoBannerTitle}
                titleFontColor={props.cmsData?.attributes?.InfoBanner?.InfoBannerTitleColor}
                description={props.cmsData?.attributes?.InfoBanner?.InfoBannerDescription}
                descriptionFontColor={
                  props.cmsData?.attributes?.InfoBanner?.InfoBannerDescriptionColor
                }
                number={props.cmsData?.attributes?.InfoBanner?.InfoBannerDescriptionNumber}
                CTAtext={props.cmsData?.attributes?.InfoBanner?.CTAText}
                CTATextColor={props.cmsData?.attributes?.InfoBanner?.CTATextColor}
                CTABackgroundColor={props.cmsData?.attributes?.InfoBanner?.CTABackgroundColor}
                isCTAVisible={props.cmsData?.attributes?.InfoBanner?.CTAVisible}
                CTAAriaLabel={props.cmsData?.attributes?.InfoBanner?.CTAAriaLabel}
                CTALink={props.cmsData?.attributes?.InfoBanner?.CTALink}
              />
            </Grid>
          )}
          {props.cmsData?.attributes?.BB_FAQ_List.length > 0 && (
            <Grid
              xs={12}
              sx={{
                background: theme.palette.primary.backgroundColor3,
                ...styles(theme).faqContainerSuperMain,
              }}
            >
              <FaqContainer
                InsuranceHeading={props.cmsData?.attributes?.BB_FAQ_Title}
                InsuranceList={props.cmsData?.attributes?.BB_FAQ_List}
              />
            </Grid>
          )}
          {showModal.value && <LoginMain403 />}
          {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
            <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
          )}
          {errorBBModal.value && !showModal.value && !showSessionExpiredModal.value && (
            <ErrorModal
              errorBBModal={errorBBModal}
              occurences={1}
              currentOccurence={errorModalOccurence}
              ctaMethod={() => {}}
            />
          )}
        </>
      )}
      {isMBBJourney && (
        <MbbContainer
          showOnBroadband
          cmsData={props.cmsDataMobile}
          cmsMBBTitle={props.cmsData?.attributes?.Prequal?.MBBTitleAfterPrequal}
          sx={{ pb: 2 }}
        />
      )}
      {isR6NGB && (
        <Grid item xs={12} md={12}>
          {/* <BroadbandPrequalSecondaryBannerCurve cmsData={props.cmsData?.attributes?.Prequal} /> */}
          <BroadbandContentCarousel
            contentTitle={props?.cmsData?.attributes?.R6_NGB_ContentTiles?.Title}
            contentDescription={props?.cmsData?.attributes?.R6_NGB_ContentTiles?.Description}
            contentCarousel={props?.cmsData?.attributes?.R6_NGB_ContentTiles?.Tiles}
            contentBackground={props?.cmsData?.attributes?.R6_NGB_ContentTiles?.BackgroundColor}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default BroadbandContainer;
